// extracted by mini-css-extract-plugin
export default {"boardHeader":"BoardView_boardHeader__Kx-Z5"};